import { HttpRequestError } from "./fetchJson";

export const ACCESS_DENIED_MESSAGE = "You don't have access to this feature.";

// A stable id collapses repeat 403s (background refetch, polling, retries) onto
// a single toast instead of stacking one per failed request.
export const ACCESS_DENIED_TOAST_ID = "access-denied";

// Errors reach the query cache as HttpRequestError, but callers that bypass
// fetchJson can throw a bare `{ response }` shape, so read both.
export function httpStatusOf(error: unknown): number | undefined {
	if (error instanceof HttpRequestError) return error.response.status;

	const candidate = error as { response?: { status?: unknown } } | null;
	const status = candidate?.response?.status;

	return typeof status === "number" ? status : undefined;
}

// 401 is the only status that means the session is gone. 403 is authenticated
// but unauthorised — the session stays valid, so it must never force a logout.
export function isAuthExpired(error: unknown): boolean {
	return httpStatusOf(error) === 401;
}

export function isAccessDenied(error: unknown): boolean {
	return httpStatusOf(error) === 403;
}
